import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { jsx as _jsx } from "react/jsx-runtime";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
export var BarChartComponent = function BarChartComponent(props) {
  var data = props.data,
      maxHorizontalValue = props.maxHorizontalValue,
      label = props.label,
      color = props.color;
  var title = label.title,
      horizontalAxisLabel = label.horizontalAxisLabel,
      verticalAxisLabel = label.verticalAxisLabel;
  var gap = Math.ceil(maxHorizontalValue / 10);
  var options = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: "".concat(title),
        font: {
          size: 16,
          weight: '600'
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "".concat(horizontalAxisLabel),
          font: {
            size: 14,
            weight: '400'
          }
        }
      },
      y: {
        min: 0,
        max: maxHorizontalValue,
        ticks: {
          precision: 0,
          stepSize: gap
        },
        title: {
          display: true,
          text: "".concat(verticalAxisLabel),
          font: {
            size: 14,
            weight: '400'
          }
        }
      }
    }
  };
  var chartData = data && {
    labels: data.map(function (item) {
      return item.horizontalAxisData;
    }),
    datasets: [{
      label: "".concat(verticalAxisLabel),
      data: data.map(function (item) {
        return item.verticalAxisData;
      }),
      backgroundColor: "".concat(color),
      barPercentage: 0.25,
      categoryPercentage: 1
    }]
  };
  return /*#__PURE__*/_jsx(Bar, {
    options: options,
    data: chartData
  });
};